import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

export default ({ app, Vue }) => {
  const appVersion = app.store.getters.appVersion

  Vue.prototype.$userContact = {
    'email': ''
  }

  let sentryEnv = 'devel'
  if (process.env.PROD) {
    sentryEnv = 'prod'
  }

  if (sentryEnv === 'prod') {
    Sentry.init({
      release: `RESTAUROVANI-UI@${appVersion}`,
      environment: sentryEnv,
      dsn: 'https://2828ae1a2cf64e69acb77166ed2da2ab@cis-sentry.vscht.cz/8',
      integrations: [new Integrations.Vue({ Vue, attachProps: true })],
      beforeBreadcrumb (breadcrumb, hint) {
        if (breadcrumb.category === 'xhr') {
          hint.xhr.__sentry_xhr__.response = hint.xhr.responseText.slice(0, 2000)
          breadcrumb.data = hint.xhr.__sentry_xhr__
        }
        return breadcrumb
      },
      beforeSend (event, hint) {
        // Check if it is an exception, and if so, show the report dialog
        if (event.exception) {
          Sentry.showReportDialog({
            title: 'Něco se pokazilo :-(',
            labelClose: 'Zavřít',
            eventId: event.event_id,
            user: {
              email: Vue.prototype.$userContact.email
            }
          })
        }
        return event
      }
    })
  }
}
